module.exports = __webpack_public_path__ + "img/icon_tab1.0f667a5a.png";